// eslint-disable-next-line import/no-extraneous-dependencies
import { configureStore, combineReducers } from '@reduxjs/toolkit';

import callReducer from './slices/call-slice';
import dialerReducer from './slices/dialer-slice';
import uploadReducer from './slices/upload-slice';
import audioReducer from './slices/audio-seek-slice';
import audioDeviceReducer from './slices/audio-device-slice';
import transcriptionReducer from './slices/transcription-slice';

const rootReducer = combineReducers({
  // Add your reducers here
  call: callReducer,
  dialer: dialerReducer,
  audioSeek: audioReducer,
  audioDevice: audioDeviceReducer,
  upload: uploadReducer,
  transcription: transcriptionReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable checks
    }),
  devTools: true,
  // other store enhancers if needed
});

export function getSessionById(sessionId) {
  const { sessions } = store.getState().call; // adjust path according to your store
  return sessions.find((s) => s.id === sessionId);
}
